import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
const games = [{
  id: 1,
  title: 'Vespertine Hollow',
  genre: 'Psychological Horror',
  description: "Explore the rotting corridors of an abandoned asylum where the walls don't just have ears—they have memories. A descent into madness where your own sanity is the resource you must manage.",
  image: 'https://images.unsplash.com/photo-1509248961158-e54f6934749c?q=80&w=2637&auto=format&fit=crop',
  tags: ['First Person', 'Survival', 'Narrative']
}, {
  id: 2,
  title: 'The Crimson Veil',
  genre: 'Gothic Mystery',
  description: "London, 1888. A detective story where the clues are written in blood and the suspects aren't entirely human. Uncover a conspiracy that threatens to plunge the empire into eternal night.",
  image: 'https://images.unsplash.com/photo-1505506874110-6a7a69069a08?q=80&w=2574&auto=format&fit=crop',
  tags: ['Point & Click', 'Detective', 'Noir']
}, {
  id: 3,
  title: 'Echoes of Malachite',
  genre: 'Cosmic Horror',
  description: "Deep beneath the Pacific, Research Station Malachite has gone silent. What they found in the trench wasn't meant to be disturbed. Now, the pressure isn't the only thing crushing you.",
  image: 'https://images.unsplash.com/photo-1682687220742-aba13b6e50ba?q=80&w=2670&auto=format&fit=crop',
  tags: ['Sci-Fi', 'Thalassophobia', 'Action']
}];
export function GamesSection() {
  return <section id="games" className="py-24 bg-abyss relative" data-id="element-78">
      <div className="max-w-7xl mx-auto px-6" data-id="element-79">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-80">
          <div data-id="element-81">
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-82">
              Featured <span className="text-mystic-500" data-id="element-83">Titles</span>
            </h2>
            <p className="text-gray-400" data-id="element-84">
              Curated experiences from the edge of sanity.
            </p>
          </div>
          <Button variant="secondary" className="group" data-id="element-85">
            View All Games{' '}
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-86" />
          </Button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-87">
          {games.map((game, index) => <motion.div key={game.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="group relative bg-shadow rounded-xl overflow-hidden border border-white/5 hover:border-mystic-500/30 transition-all duration-500" data-id="element-88">
              {/* Image Container */}
              <div className="h-64 overflow-hidden relative" data-id="element-89">
                <div className="absolute inset-0 bg-gradient-to-t from-shadow to-transparent z-10" data-id="element-90" />
                <img src={game.image} alt={game.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" data-id="element-91" />
                <div className="absolute top-4 right-4 z-20" data-id="element-92">
                  <span className="px-3 py-1 bg-black/50 backdrop-blur-md border border-white/10 rounded-full text-xs font-bold text-white uppercase tracking-wider" data-id="element-93">
                    {game.genre}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 relative z-20 -mt-12" data-id="element-94">
                <h3 className="text-2xl font-serif font-bold text-white mb-2 group-hover:text-mystic-400 transition-colors" data-id="element-95">
                  {game.title}
                </h3>
                <div className="flex gap-2 mb-4" data-id="element-96">
                  {game.tags.map(tag => <span key={tag} className="text-xs text-gray-500 border border-white/5 px-2 py-1 rounded" data-id="element-97">
                      {tag}
                    </span>)}
                </div>
                <p className="text-gray-400 text-sm leading-relaxed mb-6 line-clamp-3" data-id="element-98">
                  {game.description}
                </p>
                <Button variant="ghost" className="w-full border border-white/10 hover:border-mystic-500 hover:bg-mystic-900/20" data-id="element-99">
                  View Details
                </Button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}